import { html } from 'lit-html';
import PanelLayout from "../../model/PanelLayout";

const iconMaximize = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-maximize">
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
  </svg>
`;

const iconMinimize = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minimize">
    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
  </svg>
`;

const iconClose = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus">
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
`;

const panelResize = (onResize) => html`
  <div class="panel-resize">
    <button class="resize-min" @click=${() => onResize(PanelLayout.MIN)}>${iconClose()}</button>
    <button class="resize-fit" @click=${() => onResize(PanelLayout.FIT)}>${iconMinimize()}</button>
    <button class="resize-max" @click=${() => onResize(PanelLayout.MAX)}>${iconMaximize()}</button>
  </div>
`;

export {
  panelResize
}
